import React from "react";
import { History } from "history";
import { Box, Botao, CampoEstatico, Alerta, TipoAlerta, TipoBotao, CampoTexto, PosicaoTituloCampoTexto, } from "@intechprev/componentes-web";

import { FuncionarioService, EmprestimoService } from "../../../../services";
import { Page } from "../../..";
import { NumFuncionalidade } from "../../../Page";
import { FuncionarioDados, ParametrosSimulacao, ContratoDisponivel, ParametrosContrato } from "../../../../entidades";

interface IProps {
  history?: History;
}

interface IState {
  funcionario: FuncionarioDados;
  oidArquivoUpload: string;

  valorMargemConsignavel: number;
  contrato: ContratoDisponivel;
  tokenDigitado: string;
  tokenEnviado: string;
  // ativo: boolean;

  aderiuContratoEmpréstimoOnline: boolean;
  erro: string;
}

export class EmprestimoSimuladorContratacao extends React.Component<IProps, IState> {

  private page = React.createRef<Page>();

  private fileUpload: any;

  state: IState = {
    funcionario: null,
    oidArquivoUpload: "",

    valorMargemConsignavel: 0,
    contrato: null,

    tokenDigitado: "",
    tokenEnviado: "",
    // ativo: false,

    aderiuContratoEmpréstimoOnline: false,
    erro: null
  };

  componentDidMount = async () => {
    await this.page.current.loading(true);

    try {
      const dados: ParametrosSimulacao = JSON.parse(localStorage.getItem("emprestimo-parametros"));

      const contrato: ContratoDisponivel = JSON.parse(localStorage.getItem("emprestimo-contrato-selecionado"));

      const funcionario = await FuncionarioService.Buscar();

      // const aderiuContratoEmpréstimoOnline = funcionario.DadosPessoais.ID_EMP_ONLINE === "S";
      const aderiuContratoEmpréstimoOnline = true;

      await this.setState({
        funcionario,
        valorMargemConsignavel: dados.ValorMargem,
        contrato,
        // ativo: ["1"].includes(dados.plano.CD_CATEGORIA),
        aderiuContratoEmpréstimoOnline
      });
    } catch (err) {
      const error: any = err;
      this.setState({
        erro: error.response ? error.response.data : error,
      });
    }
    finally {
      await this.page.current.loading(false);
    }
  };

  contratar = async () => {
    try {
      const dados: ParametrosContrato = {
        Contrato: this.state.contrato,
        ValorMargem: this.state.valorMargemConsignavel,
        TokenEnviado: this.state.tokenEnviado,
        TokenDigitado: this.state.tokenDigitado
      };
      // const numContrato = await EmprestimoService.Contratar(dados);
      await EmprestimoService.Contratar(dados);
      alert("Sua solicitação foi enviada com sucesso!");

      this.props.history.push("/emprestimo");
    } catch (err) {
      const error: any = err;
      this.setState({
        erro: error.response ? error.response.data : error,
      });
    };
  }

  enviarToken = async () => {
    try {
      var token = await EmprestimoService.GerarToken();
      this.setState({
        tokenEnviado: token
      });
      alert("Para validar a operação de empréstimo, insira o código que foi enviado por SMS ao seu celular ou ao seu email e clique em contratar empréstimo.");
    } catch (err) {
      const error: any = err;
      this.setState({
        erro: error.response ? error.response.data : error,
      });
    }
  };

  render() {
    return (
      <Page {...this.props} Funcionalidade={NumFuncionalidade.EMPRESTIMOS_CONTRATAÇÃO} ref={this.page}>

        {this.state.erro && <Alerta tipo={TipoAlerta.danger} mensagem={this.state.erro} />}

        {!this.state.erro && <>
          {!this.state.aderiuContratoEmpréstimoOnline && (
            <Alerta
              tipo={TipoAlerta.danger}
              mensagem={
                "Você não pode usar esta funcionalidade, pois não aderiu ao contrato de empréstimo on-line. Para aderir, entre em contato com nossa equipe da Seguridade através do e-mail seguridade@previrb.com.br ou pelo telefone 21 2277-1999, de segunda a sexta-feira, das 9h às 17h."
              }
            />
          )}

          {this.state.aderiuContratoEmpréstimoOnline && (
            <>
              <h3>Bem-Vindo ao Simulador de Empréstimos da São Francisco!</h3>
              {/* <h5>Ao final da sua simulação você poderá realizar o requerimento do seu empréstimo diretamente por aqui, de forma on-line e segura!</h5> */}

              {!(this.state.funcionario &&
                this.state.funcionario.Entidade &&
                this.state.funcionario.Entidade.NUM_BANCO &&
                this.state.funcionario.Entidade.NUM_AGENCIA &&
                this.state.funcionario.Entidade.NUM_CONTA) && (
                  <>
                    <Alerta tipo={TipoAlerta.danger} mensagem={"Você não possui dados bancários cadastrados, favor enviar um comprovante para nossa central de atendimento, indicando a sua matrícula."} />
                  </>
                )}

              {(this.state.funcionario &&
                this.state.funcionario.Entidade &&
                this.state.funcionario.Entidade.NUM_BANCO &&
                this.state.funcionario.Entidade.NUM_AGENCIA &&
                this.state.funcionario.Entidade.NUM_CONTA) && (
                  <>
                    <Box titulo={"Requerimento do Empréstimo"} renderRow>
                      <Box titulo={"Dados Bancários"}>
                        <CampoEstatico titulo={"Banco"} valor={this.state.funcionario.Entidade.NUM_BANCO} tamanhoTitulo={"md-4"} />

                        <CampoEstatico titulo={"Agência"} valor={this.state.funcionario.Entidade.NUM_AGENCIA} tamanhoTitulo={"md-4"} />

                        <CampoEstatico titulo={"Conta"} valor={this.state.funcionario.Entidade.NUM_CONTA} tamanhoTitulo={"md-4"} />
                      </Box>

                      {/* {this.state.ativo && (
                      <ArquivoUpload
                        texto={
                          'Para concluir a sua solicitação de empréstimo é necessário enviar o seu último contracheque contendo a margem consignável informada por você. Somente será possível enviar arquivos "TIF, JPG, BMP, PNG e PDF".'
                        }
                        titulo={"Comprovante Margem Consignável"}
                        id={"documento"}
                        setOidArquivoUpload={this.setOidArquivoUpload}
                      />
                    )} */}

                      <Box titulo={"Código de Validação"}>
                        <p>
                          {"Para dar sequência a sua solicitação de empréstimo, "}
                          <b>{"enviaremos um código de validação para o seu e-mail cadastrado na São Francisco."}</b>
                        </p>

                        <Botao
                          className={"mb-3"}
                          onClick={this.enviarToken}
                          titulo={"Solicitar código de validação"}
                          tipo={TipoBotao.primary}
                          usaLoading
                        />

                        <CampoTexto
                          titulo={"Digite aqui o Código de Validação recebido via E-mail"}
                          posicaoTitulo={PosicaoTituloCampoTexto.cima}
                          valor={this.state.tokenDigitado}
                          nome={"tokenDigitado"}
                          contexto={this}
                        />
                      </Box>

                      <Botao
                        titulo={"Solicitar empréstimo!"}
                        className={"ml-2"}
                        onClick={this.contratar}
                        icone={"fas fa-chevron-right"}
                        usaLoading
                        iconeDireita
                        submit
                      />
                    </Box>
                  </>
                )}
            </>
          )}
        </>}
      </Page>
    );
  }
}
